import { Hero } from "@/components/aranon/Hero";
import { Products } from "@/components/aranon/Products";
import { Statement } from "@/components/aranon/Statement";
import { HowWeWork } from "@/components/aranon/HowWeWork";
import { Sectors } from "@/components/aranon/Sectors";
import { Testimonials } from "@/components/aranon/Testimonials";
import { Beliefs } from "@/components/aranon/Beliefs";
import { EngagementModel } from "@/components/aranon/EngagementModel";
import { CTASection } from "@/components/aranon/CTASection";
import { Seo } from "@/components/aranon/Seo";
import { useTranslation } from "react-i18next";
import { faqPage } from "@/lib/seo-jsonld";

const Index = () => {
  const { t, i18n } = useTranslation();
  const isPt = (i18n.language || "en").startsWith("pt");
  const faq = isPt
    ? [
        { q: "O que a Aranon faz?", a: "A Aranon é um studio de engenharia de IA que constrói software de inteligência artificial sob medida para empresas: agentes de IA, copilotos, plataformas de dados e automação ponta a ponta." },
        { q: "Para quais setores a Aranon entrega IA?", a: "Atuamos em saúde e OPME, indústria e manufatura, energia e infraestrutura, telecom, redes de franquias e setor público / licitações." },
        { q: "A Aranon atende empresas brasileiras e internacionais?", a: "Sim. Operamos para empresas no Brasil e no exterior, em inglês e português, com entrega remota e on-site quando necessário." },
        { q: "Quais soluções de IA a Aranon oferece?", a: "Cinco plataformas integradas: NAIP (inteligência estratégica), FORGE (fundação de dados), AXIS (copilotos para o time), PULSE (motor de conhecimento) e CORE (plataformas customizadas)." },
        { q: "Como contratar a Aranon?", a: "Dois modelos: parceiro estratégico por projeto ou venture studio com equity. Fale com o fundador pelo formulário de contato ou WhatsApp." },
      ]
    : [
        { q: "What does Aranon do?", a: "Aranon is an AI engineering studio that builds custom AI software for enterprises: AI agents, copilots, data platforms and end-to-end automation." },
        { q: "Which sectors does Aranon serve?", a: "Healthcare & OPME, industry & manufacturing, energy & infrastructure, telecom, franchise networks and public sector procurement." },
        { q: "Does Aranon work with companies outside Brazil?", a: "Yes. We work with companies globally, in English and Portuguese, remotely and on-site when needed." },
        { q: "What AI solutions does Aranon offer?", a: "Five integrated platforms: NAIP (strategic intelligence), FORGE (data foundation), AXIS (workforce copilots), PULSE (knowledge engine) and CORE (custom platforms)." },
        { q: "How do I engage Aranon?", a: "Two models: strategic project partner or equity-based venture studio. Reach the founder through the contact form or WhatsApp." },
      ];
  return (
    <>
      <Seo
        title={`Aranon — AI Software Development for Enterprises | ${t("nav.tagline")}`}
        description={t("hero.desc")}
        path="/"
        jsonLd={faqPage(faq)}
      />
      <Hero />
      <Products />
      <Statement />
      <HowWeWork />
      <Sectors />
      <Testimonials />
      <Beliefs />
      <EngagementModel />
      <CTASection />
    </>
  );
};

export default Index;
